import React from "react";
import { Modal, Typography, Space, Button } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

/**
 * Genel silme onay modal'ı
 * @param {Object} props
 * @param {boolean} props.visible - Modal görünürlüğü
 * @param {Function} props.onCancel - İptal callback
 * @param {Function} props.onConfirm - Onay callback
 * @param {string} props.title - Modal başlığı
 * @param {string} props.itemName - Silinecek öğenin adı
 * @param {React.ReactNode} props.itemDetails - Silinecek öğenin detayları (opsiyonel)
 * @param {boolean} props.loading - Yükleme durumu
 * @param {string} props.confirmText - Onay butonu metni (varsayılan: "Evet, Sil")
 * @param {string} props.cancelText - İptal butonu metni (varsayılan: "İptal")
 * @param {string} props.warningText - Uyarı metni (varsayılan: "Bu işlem geri alınamaz.")
 */
const ConfirmDeleteModal = ({
  visible,
  onCancel,
  onConfirm,
  title = "Silme Onayı",
  itemName,
  itemDetails,
  loading = false,
  confirmText = "Evet, Sil",
  cancelText = "İptal",
  warningText = "Bu işlem geri alınamaz.",
}) => {
  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: "#faad14", fontSize: "20px" }} />
          <span>{title}</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          icon={<DeleteOutlined />}
          loading={loading}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>,
      ]}
      width={400}
      centered
    >
      <div style={{ padding: "20px 0" }}>
        <Title level={5} style={{ marginBottom: 16 }}>
          Emin misiniz?
        </Title>

        {itemName && (
          <Text>
            <strong>{itemName}</strong> silmek istediğinizden emin misiniz?
          </Text>
        )}

        {itemDetails && (
          <div
            style={{
              background: "#f5f5f5",
              padding: "12px",
              borderRadius: "6px",
              marginTop: "12px",
              marginBottom: "12px",
            }}
          >
            {itemDetails}
          </div>
        )}

        {warningText && (
          <div style={{ marginTop: 16 }}>
            <Text type="warning">{warningText}</Text>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
